<div class="card p-3">

    <h1 class="mb-4">Cookie Policy</h1>

    <div class="content">
        <p><em>Synectics plc, owner of www.synxcloud.com</em></p>
        <p>Our Website uses cookies to distinguish you from other users of our Website. This helps us to provide you with a good experience when you browse our Website and also allows us to improve our site. By accepting cookies on this site you accept the terms of this policy.</p>
        <p>A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer’s hard drive.</p>
        <p>We use the following cookies:</p>
        <ul>
            <li><b>Strictly necessary cookies.</b> These are cookies that are required for the operation of our Website. They include, for example, cookies that enable you to log into secure areas of our Website or to make use of e-billing services.</li>
            <li><b>Analytical/performance cookies.</b> They allow us to recognise and count the number of visitors and to see how visitors move around our Website when they are using it. This helps us to improve the way our Website works, for example, by ensuring that users are finding what they are looking for easily.</li>
            <li><b>Functionality cookies</b>. These are used to recognise you when you return to our Website. This enables us to personalise our content for you, greet you by name and remember your preferences (for example, your choice of language or region).</li>
            <li><b>Targeting cookies.</b> These cookies record your visit to our Website, the pages you have visited and the links you have followed. We will use this information to make our Website and the advertising displayed on it more relevant to your interests. We may also share this information with third parties for this purpose.</li>
        </ul>
        <p>You can find more information about the individual cookies we use and the purposes for which we use them in the table below:</p>
        <table border="1">
            <thead>
            <tr>
                <th style="width: 20%;" align="left">Cookie</th>
                <th style="width: 20%;" align="left">Name</th>
                <th style="width: 60%;" align="left">Purpose</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Populate with cookies</td>
                <td></td>
                <td></td>
            </tr>

            </tbody>
        </table>
        <p><br>Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies.</p>
        <p>You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our site.</p>
        <p>Except for essential cookies, all cookies will expire after two years.</p>
    </div>

</div>
